function toMillis (value) {
  return typeof value.toMillis === "function" ? value.toMillis() : value;
}

// True when the scorecard was updated after the given stream's last rating write,
// meaning writing again now would clobber ratings produced elsewhere.
export function isScorecardStale (scorecardUpdatedAt, ratingsSyncedAt) {
  if (scorecardUpdatedAt == null || ratingsSyncedAt == null) return false;
  return toMillis(scorecardUpdatedAt) > toMillis(ratingsSyncedAt);
}